export const MAP_EDIT_ACTIONS = {
  DRAW_IMAGE: 'DRAW_IMAGE',
  ADD_TEXT: 'ADD_TEXT',
  ADD_RECT: 'ADD_RECT',
  ADD_OVAL: 'ADD_OVAL',
  ADD_LINE: 'ADD_LINE',
  TRANSFORM_IMAGE: 'TRANSFORM_IMAGE',
} as const;
